import { IStructureNode } from './types';

type ITitledNode = Pick<IStructureNode, 'name' | 'legalName'>;

/**
 * A legal name worth showing: trimmed, and absent when blank.
 *
 * `??` alone is not enough: the company sync writes '' when no source has a legal name.
 */
export function toLegalName(value: string | null | undefined): string | undefined {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
}

/**
 * What a card is titled: the legal name, or the display name where none is on record.
 *
 * One definition for the canvas card and the exported one, so the screen and the file agree.
 */
export function cardTitle(node: ITitledNode): string {
  return toLegalName(node.legalName) ?? node.name;
}

/**
 * The card's hover text: the full title, which the card clamps to two lines, and the
 * display name beneath it when the two differ.
 */
export function cardHoverText(node: ITitledNode): string {
  const title = cardTitle(node);
  return title === node.name ? title : `${title}\nDisplay name: ${node.name}`;
}
